import { createStore } from "@xstate/store";

/**
 * Which backend chat thread the agent UI is currently bound to (null = empty state).
 *
 * Selection only — the conversation itself belongs to the thread's `Chat` in
 * `lib/agent-chat/chat-registry`. This store once also held a `pendingMessage`
 * to bridge "type-in-empty-state-and-send" across the create-then-mount gap;
 * the empty-state composer now sends into the new thread's `Chat` directly, so
 * there is no window to bridge and no mailbox for a second mounted surface to
 * consume as well.
 */
export const agentActiveThreadStore = createStore({
  context: {
    activeThreadId: null as string | null,
  },
  on: {
    "active.set": (_ctx, e: { threadId: string | null }) => ({ activeThreadId: e.threadId }),
    "active.clear": () => ({ activeThreadId: null }),
  },
});
